/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgIdIndexRouteImport } from './routes/$orgId/index'
import { Route as OrgIdDashboardRouteRouteImport } from './routes/$orgId/dashboard/route'
import { Route as OrgIdDashboardIndexRouteImport } from './routes/$orgId/dashboard/index'
import { Route as OrgIdDashboardUsersRouteImport } from './routes/$orgId/dashboard/users'
import { Route as OrgIdDashboardStorageRouteImport } from './routes/$orgId/dashboard/storage'
import { Route as OrgIdDashboardSshkeysRouteImport } from './routes/$orgId/dashboard/sshkeys'
import { Route as OrgIdDashboardSettingsRouteImport } from './routes/$orgId/dashboard/settings'
import { Route as OrgIdDashboardProfileRouteImport } from './routes/$orgId/dashboard/profile'
import { Route as OrgIdDashboardHomeRouteImport } from './routes/$orgId/dashboard/home'
import { Route as OrgIdDashboardBillingRouteImport } from './routes/$orgId/dashboard/billing'
import { Route as OrgIdDashboardAuditRouteImport } from './routes/$orgId/dashboard/audit'
import { Route as OrgIdDashboardApikeysRouteImport } from './routes/$orgId/dashboard/apikeys'
import { Route as OrgIdDashboardTemplatesIndexRouteImport } from './routes/$orgId/dashboard/templates/index'
import { Route as OrgIdDashboardServersIndexRouteImport } from './routes/$orgId/dashboard/servers/index'
import { Route as OrgIdDashboardTemplatesNewRouteImport } from './routes/$orgId/dashboard/templates/new'
import { Route as OrgIdDashboardServersNewRouteImport } from './routes/$orgId/dashboard/servers/new'
import { Route as OrgIdDashboardServersServerIdRouteImport } from './routes/$orgId/dashboard/servers/$serverId'

const SettingsLazyRouteImport = createFileRoute('/settings')()
const LoginLazyRouteImport = createFileRoute('/login')()
const ClustersLazyRouteImport = createFileRoute('/clusters')()
const AboutLazyRouteImport = createFileRoute('/about')()
const InternalTemplateEditorLazyRouteImport = createFileRoute(
  '/internal/template-editor',
)()
const InternalBashEditorLazyRouteImport = createFileRoute(
  '/internal/bash-editor',
)()

const SettingsLazyRoute = SettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const ClustersLazyRoute = ClustersLazyRouteImport.update({
  id: '/clusters',
  path: '/clusters',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/clusters.lazy').then((d) => d.Route))
const AboutLazyRoute = AboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIdIndexRoute = OrgIdIndexRouteImport.update({
  id: '/$orgId/',
  path: '/$orgId/',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalTemplateEditorLazyRoute =
  InternalTemplateEditorLazyRouteImport.update({
    id: '/internal/template-editor',
    path: '/internal/template-editor',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/internal/template-editor.lazy').then((d) => d.Route),
  )
const InternalBashEditorLazyRoute = InternalBashEditorLazyRouteImport.update({
  id: '/internal/bash-editor',
  path: '/internal/bash-editor',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/internal/bash-editor.lazy').then((d) => d.Route),
)
const OrgIdDashboardRouteRoute = OrgIdDashboardRouteRouteImport.update({
  id: '/$orgId/dashboard',
  path: '/$orgId/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIdDashboardIndexRoute = OrgIdDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardUsersRoute = OrgIdDashboardUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardStorageRoute = OrgIdDashboardStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardSshkeysRoute = OrgIdDashboardSshkeysRouteImport.update({
  id: '/sshkeys',
  path: '/sshkeys',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardSettingsRoute = OrgIdDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardProfileRoute = OrgIdDashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardHomeRoute = OrgIdDashboardHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardBillingRoute = OrgIdDashboardBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardAuditRoute = OrgIdDashboardAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardApikeysRoute = OrgIdDashboardApikeysRouteImport.update({
  id: '/apikeys',
  path: '/apikeys',
  getParentRoute: () => OrgIdDashboardRouteRoute,
} as any)
const OrgIdDashboardTemplatesIndexRoute =
  OrgIdDashboardTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => OrgIdDashboardRouteRoute,
  } as any)
const OrgIdDashboardServersIndexRoute =
  OrgIdDashboardServersIndexRouteImport.update({
    id: '/servers/',
    path: '/servers/',
    getParentRoute: () => OrgIdDashboardRouteRoute,
  } as any)
const OrgIdDashboardTemplatesNewRoute =
  OrgIdDashboardTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => OrgIdDashboardRouteRoute,
  } as any)
const OrgIdDashboardServersNewRoute =
  OrgIdDashboardServersNewRouteImport.update({
    id: '/servers/new',
    path: '/servers/new',
    getParentRoute: () => OrgIdDashboardRouteRoute,
  } as any)
const OrgIdDashboardServersServerIdRoute =
  OrgIdDashboardServersServerIdRouteImport.update({
    id: '/servers/$serverId',
    path: '/servers/$serverId',
    getParentRoute: () => OrgIdDashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutLazyRoute
  '/clusters': typeof ClustersLazyRoute
  '/login': typeof LoginLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/$orgId/dashboard': typeof OrgIdDashboardRouteRouteWithChildren
  '/internal/bash-editor': typeof InternalBashEditorLazyRoute
  '/internal/template-editor': typeof InternalTemplateEditorLazyRoute
  '/$orgId': typeof OrgIdIndexRoute
  '/$orgId/dashboard/apikeys': typeof OrgIdDashboardApikeysRoute
  '/$orgId/dashboard/audit': typeof OrgIdDashboardAuditRoute
  '/$orgId/dashboard/billing': typeof OrgIdDashboardBillingRoute
  '/$orgId/dashboard/home': typeof OrgIdDashboardHomeRoute
  '/$orgId/dashboard/profile': typeof OrgIdDashboardProfileRoute
  '/$orgId/dashboard/settings': typeof OrgIdDashboardSettingsRoute
  '/$orgId/dashboard/sshkeys': typeof OrgIdDashboardSshkeysRoute
  '/$orgId/dashboard/storage': typeof OrgIdDashboardStorageRoute
  '/$orgId/dashboard/users': typeof OrgIdDashboardUsersRoute
  '/$orgId/dashboard/': typeof OrgIdDashboardIndexRoute
  '/$orgId/dashboard/servers/$serverId': typeof OrgIdDashboardServersServerIdRoute
  '/$orgId/dashboard/servers/new': typeof OrgIdDashboardServersNewRoute
  '/$orgId/dashboard/templates/new': typeof OrgIdDashboardTemplatesNewRoute
  '/$orgId/dashboard/servers': typeof OrgIdDashboardServersIndexRoute
  '/$orgId/dashboard/templates': typeof OrgIdDashboardTemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutLazyRoute
  '/clusters': typeof ClustersLazyRoute
  '/login': typeof LoginLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/internal/bash-editor': typeof InternalBashEditorLazyRoute
  '/internal/template-editor': typeof InternalTemplateEditorLazyRoute
  '/$orgId': typeof OrgIdIndexRoute
  '/$orgId/dashboard/apikeys': typeof OrgIdDashboardApikeysRoute
  '/$orgId/dashboard/audit': typeof OrgIdDashboardAuditRoute
  '/$orgId/dashboard/billing': typeof OrgIdDashboardBillingRoute
  '/$orgId/dashboard/home': typeof OrgIdDashboardHomeRoute
  '/$orgId/dashboard/profile': typeof OrgIdDashboardProfileRoute
  '/$orgId/dashboard/settings': typeof OrgIdDashboardSettingsRoute
  '/$orgId/dashboard/sshkeys': typeof OrgIdDashboardSshkeysRoute
  '/$orgId/dashboard/storage': typeof OrgIdDashboardStorageRoute
  '/$orgId/dashboard/users': typeof OrgIdDashboardUsersRoute
  '/$orgId/dashboard': typeof OrgIdDashboardIndexRoute
  '/$orgId/dashboard/servers/$serverId': typeof OrgIdDashboardServersServerIdRoute
  '/$orgId/dashboard/servers/new': typeof OrgIdDashboardServersNewRoute
  '/$orgId/dashboard/templates/new': typeof OrgIdDashboardTemplatesNewRoute
  '/$orgId/dashboard/servers': typeof OrgIdDashboardServersIndexRoute
  '/$orgId/dashboard/templates': typeof OrgIdDashboardTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutLazyRoute
  '/clusters': typeof ClustersLazyRoute
  '/login': typeof LoginLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/$orgId/dashboard': typeof OrgIdDashboardRouteRouteWithChildren
  '/internal/bash-editor': typeof InternalBashEditorLazyRoute
  '/internal/template-editor': typeof InternalTemplateEditorLazyRoute
  '/$orgId/': typeof OrgIdIndexRoute
  '/$orgId/dashboard/apikeys': typeof OrgIdDashboardApikeysRoute
  '/$orgId/dashboard/audit': typeof OrgIdDashboardAuditRoute
  '/$orgId/dashboard/billing': typeof OrgIdDashboardBillingRoute
  '/$orgId/dashboard/home': typeof OrgIdDashboardHomeRoute
  '/$orgId/dashboard/profile': typeof OrgIdDashboardProfileRoute
  '/$orgId/dashboard/settings': typeof OrgIdDashboardSettingsRoute
  '/$orgId/dashboard/sshkeys': typeof OrgIdDashboardSshkeysRoute
  '/$orgId/dashboard/storage': typeof OrgIdDashboardStorageRoute
  '/$orgId/dashboard/users': typeof OrgIdDashboardUsersRoute
  '/$orgId/dashboard/': typeof OrgIdDashboardIndexRoute
  '/$orgId/dashboard/servers/$serverId': typeof OrgIdDashboardServersServerIdRoute
  '/$orgId/dashboard/servers/new': typeof OrgIdDashboardServersNewRoute
  '/$orgId/dashboard/templates/new': typeof OrgIdDashboardTemplatesNewRoute
  '/$orgId/dashboard/servers/': typeof OrgIdDashboardServersIndexRoute
  '/$orgId/dashboard/templates/': typeof OrgIdDashboardTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/about'
    | '/clusters'
    | '/login'
    | '/settings'
    | '/$orgId/dashboard'
    | '/internal/bash-editor'
    | '/internal/template-editor'
    | '/$orgId'
    | '/$orgId/dashboard/apikeys'
    | '/$orgId/dashboard/audit'
    | '/$orgId/dashboard/billing'
    | '/$orgId/dashboard/home'
    | '/$orgId/dashboard/profile'
    | '/$orgId/dashboard/settings'
    | '/$orgId/dashboard/sshkeys'
    | '/$orgId/dashboard/storage'
    | '/$orgId/dashboard/users'
    | '/$orgId/dashboard/'
    | '/$orgId/dashboard/servers/$serverId'
    | '/$orgId/dashboard/servers/new'
    | '/$orgId/dashboard/templates/new'
    | '/$orgId/dashboard/servers'
    | '/$orgId/dashboard/templates'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/about'
    | '/clusters'
    | '/login'
    | '/settings'
    | '/internal/bash-editor'
    | '/internal/template-editor'
    | '/$orgId'
    | '/$orgId/dashboard/apikeys'
    | '/$orgId/dashboard/audit'
    | '/$orgId/dashboard/billing'
    | '/$orgId/dashboard/home'
    | '/$orgId/dashboard/profile'
    | '/$orgId/dashboard/settings'
    | '/$orgId/dashboard/sshkeys'
    | '/$orgId/dashboard/storage'
    | '/$orgId/dashboard/users'
    | '/$orgId/dashboard'
    | '/$orgId/dashboard/servers/$serverId'
    | '/$orgId/dashboard/servers/new'
    | '/$orgId/dashboard/templates/new'
    | '/$orgId/dashboard/servers'
    | '/$orgId/dashboard/templates'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/about'
    | '/clusters'
    | '/login'
    | '/settings'
    | '/$orgId/dashboard'
    | '/internal/bash-editor'
    | '/internal/template-editor'
    | '/$orgId/'
    | '/$orgId/dashboard/apikeys'
    | '/$orgId/dashboard/audit'
    | '/$orgId/dashboard/billing'
    | '/$orgId/dashboard/home'
    | '/$orgId/dashboard/profile'
    | '/$orgId/dashboard/settings'
    | '/$orgId/dashboard/sshkeys'
    | '/$orgId/dashboard/storage'
    | '/$orgId/dashboard/users'
    | '/$orgId/dashboard/'
    | '/$orgId/dashboard/servers/$serverId'
    | '/$orgId/dashboard/servers/new'
    | '/$orgId/dashboard/templates/new'
    | '/$orgId/dashboard/servers/'
    | '/$orgId/dashboard/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AboutLazyRoute: typeof AboutLazyRoute
  ClustersLazyRoute: typeof ClustersLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  SettingsLazyRoute: typeof SettingsLazyRoute
  OrgIdDashboardRouteRoute: typeof OrgIdDashboardRouteRouteWithChildren
  InternalBashEditorLazyRoute: typeof InternalBashEditorLazyRoute
  InternalTemplateEditorLazyRoute: typeof InternalTemplateEditorLazyRoute
  OrgIdIndexRoute: typeof OrgIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clusters': {
      id: '/clusters'
      path: '/clusters'
      fullPath: '/clusters'
      preLoaderRoute: typeof ClustersLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgId/': {
      id: '/$orgId/'
      path: '/$orgId'
      fullPath: '/$orgId'
      preLoaderRoute: typeof OrgIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/template-editor': {
      id: '/internal/template-editor'
      path: '/internal/template-editor'
      fullPath: '/internal/template-editor'
      preLoaderRoute: typeof InternalTemplateEditorLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal/bash-editor': {
      id: '/internal/bash-editor'
      path: '/internal/bash-editor'
      fullPath: '/internal/bash-editor'
      preLoaderRoute: typeof InternalBashEditorLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgId/dashboard': {
      id: '/$orgId/dashboard'
      path: '/$orgId/dashboard'
      fullPath: '/$orgId/dashboard'
      preLoaderRoute: typeof OrgIdDashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgId/dashboard/': {
      id: '/$orgId/dashboard/'
      path: '/'
      fullPath: '/$orgId/dashboard/'
      preLoaderRoute: typeof OrgIdDashboardIndexRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/users': {
      id: '/$orgId/dashboard/users'
      path: '/users'
      fullPath: '/$orgId/dashboard/users'
      preLoaderRoute: typeof OrgIdDashboardUsersRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/storage': {
      id: '/$orgId/dashboard/storage'
      path: '/storage'
      fullPath: '/$orgId/dashboard/storage'
      preLoaderRoute: typeof OrgIdDashboardStorageRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/sshkeys': {
      id: '/$orgId/dashboard/sshkeys'
      path: '/sshkeys'
      fullPath: '/$orgId/dashboard/sshkeys'
      preLoaderRoute: typeof OrgIdDashboardSshkeysRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/settings': {
      id: '/$orgId/dashboard/settings'
      path: '/settings'
      fullPath: '/$orgId/dashboard/settings'
      preLoaderRoute: typeof OrgIdDashboardSettingsRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/profile': {
      id: '/$orgId/dashboard/profile'
      path: '/profile'
      fullPath: '/$orgId/dashboard/profile'
      preLoaderRoute: typeof OrgIdDashboardProfileRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/home': {
      id: '/$orgId/dashboard/home'
      path: '/home'
      fullPath: '/$orgId/dashboard/home'
      preLoaderRoute: typeof OrgIdDashboardHomeRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/billing': {
      id: '/$orgId/dashboard/billing'
      path: '/billing'
      fullPath: '/$orgId/dashboard/billing'
      preLoaderRoute: typeof OrgIdDashboardBillingRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/audit': {
      id: '/$orgId/dashboard/audit'
      path: '/audit'
      fullPath: '/$orgId/dashboard/audit'
      preLoaderRoute: typeof OrgIdDashboardAuditRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/apikeys': {
      id: '/$orgId/dashboard/apikeys'
      path: '/apikeys'
      fullPath: '/$orgId/dashboard/apikeys'
      preLoaderRoute: typeof OrgIdDashboardApikeysRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/templates/': {
      id: '/$orgId/dashboard/templates/'
      path: '/templates'
      fullPath: '/$orgId/dashboard/templates'
      preLoaderRoute: typeof OrgIdDashboardTemplatesIndexRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/servers/': {
      id: '/$orgId/dashboard/servers/'
      path: '/servers'
      fullPath: '/$orgId/dashboard/servers'
      preLoaderRoute: typeof OrgIdDashboardServersIndexRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/templates/new': {
      id: '/$orgId/dashboard/templates/new'
      path: '/templates/new'
      fullPath: '/$orgId/dashboard/templates/new'
      preLoaderRoute: typeof OrgIdDashboardTemplatesNewRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/servers/new': {
      id: '/$orgId/dashboard/servers/new'
      path: '/servers/new'
      fullPath: '/$orgId/dashboard/servers/new'
      preLoaderRoute: typeof OrgIdDashboardServersNewRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
    '/$orgId/dashboard/servers/$serverId': {
      id: '/$orgId/dashboard/servers/$serverId'
      path: '/servers/$serverId'
      fullPath: '/$orgId/dashboard/servers/$serverId'
      preLoaderRoute: typeof OrgIdDashboardServersServerIdRouteImport
      parentRoute: typeof OrgIdDashboardRouteRoute
    }
  }
}

interface OrgIdDashboardRouteRouteChildren {
  OrgIdDashboardApikeysRoute: typeof OrgIdDashboardApikeysRoute
  OrgIdDashboardAuditRoute: typeof OrgIdDashboardAuditRoute
  OrgIdDashboardBillingRoute: typeof OrgIdDashboardBillingRoute
  OrgIdDashboardHomeRoute: typeof OrgIdDashboardHomeRoute
  OrgIdDashboardProfileRoute: typeof OrgIdDashboardProfileRoute
  OrgIdDashboardSettingsRoute: typeof OrgIdDashboardSettingsRoute
  OrgIdDashboardSshkeysRoute: typeof OrgIdDashboardSshkeysRoute
  OrgIdDashboardStorageRoute: typeof OrgIdDashboardStorageRoute
  OrgIdDashboardUsersRoute: typeof OrgIdDashboardUsersRoute
  OrgIdDashboardIndexRoute: typeof OrgIdDashboardIndexRoute
  OrgIdDashboardServersServerIdRoute: typeof OrgIdDashboardServersServerIdRoute
  OrgIdDashboardServersNewRoute: typeof OrgIdDashboardServersNewRoute
  OrgIdDashboardTemplatesNewRoute: typeof OrgIdDashboardTemplatesNewRoute
  OrgIdDashboardServersIndexRoute: typeof OrgIdDashboardServersIndexRoute
  OrgIdDashboardTemplatesIndexRoute: typeof OrgIdDashboardTemplatesIndexRoute
}

const OrgIdDashboardRouteRouteChildren: OrgIdDashboardRouteRouteChildren = {
  OrgIdDashboardApikeysRoute: OrgIdDashboardApikeysRoute,
  OrgIdDashboardAuditRoute: OrgIdDashboardAuditRoute,
  OrgIdDashboardBillingRoute: OrgIdDashboardBillingRoute,
  OrgIdDashboardHomeRoute: OrgIdDashboardHomeRoute,
  OrgIdDashboardProfileRoute: OrgIdDashboardProfileRoute,
  OrgIdDashboardSettingsRoute: OrgIdDashboardSettingsRoute,
  OrgIdDashboardSshkeysRoute: OrgIdDashboardSshkeysRoute,
  OrgIdDashboardStorageRoute: OrgIdDashboardStorageRoute,
  OrgIdDashboardUsersRoute: OrgIdDashboardUsersRoute,
  OrgIdDashboardIndexRoute: OrgIdDashboardIndexRoute,
  OrgIdDashboardServersServerIdRoute: OrgIdDashboardServersServerIdRoute,
  OrgIdDashboardServersNewRoute: OrgIdDashboardServersNewRoute,
  OrgIdDashboardTemplatesNewRoute: OrgIdDashboardTemplatesNewRoute,
  OrgIdDashboardServersIndexRoute: OrgIdDashboardServersIndexRoute,
  OrgIdDashboardTemplatesIndexRoute: OrgIdDashboardTemplatesIndexRoute,
}

const OrgIdDashboardRouteRouteWithChildren =
  OrgIdDashboardRouteRoute._addFileChildren(OrgIdDashboardRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AboutLazyRoute: AboutLazyRoute,
  ClustersLazyRoute: ClustersLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  SettingsLazyRoute: SettingsLazyRoute,
  OrgIdDashboardRouteRoute: OrgIdDashboardRouteRouteWithChildren,
  InternalBashEditorLazyRoute: InternalBashEditorLazyRoute,
  InternalTemplateEditorLazyRoute: InternalTemplateEditorLazyRoute,
  OrgIdIndexRoute: OrgIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
